/**
 * This file is part of the "Awaken Media" project.
 *
 * (c) 2017 - CanalPlus International
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

/*       */

import { connect } from 'react-redux';
import { compose } from 'recompose';
import { withTranslation } from 'react-i18next';

import { fetchCoordinates } from 'shared/modules/geolocation/actions/index';
import getCoordinates from 'shared/modules/geolocation/selectors/getCoordonates';
import isFetchingCoordinatesPending from 'shared/modules/geolocation/selectors/isFetchingCoordinatesPending';
import { getCoordinatesFromCountryCode } from 'shared/helpers/coordinates';
import ShopMap from '../components/ShopMap';
import {
  fetchShops,
  fetchShopsDetails,
  filterShops
} from '../../shared/actions';
import { changePage, selectShop } from '../actions';
import forgeApiUrl from '../../shared/helpers/forgeApiUrl';
import {
  getFilteredShops,
  getFiltersWithOptions,
  getShopDetailsFetchingState,
  getShop
} from '../../shared/selectors';
import {
  getShopsForPage,
  getSelectedShopId,
  getCurrentPage,
  getTotalPages
} from '../selectors';

const mapStateToProps = (state, { api, countryCode }) => {
  const selectedShopId = getSelectedShopId(state);

  return {
    url: forgeApiUrl(api.url, api.parameters),
    filters: getFiltersWithOptions(state),
    shopsMap: getFilteredShops(state),
    shopsList: getShopsForPage(state),
    currentPage: getCurrentPage(state),
    totalPages: getTotalPages(state),
    isSelectedShopLoading: getShopDetailsFetchingState(selectedShopId)(state),
    selectedShop: getShop(selectedShopId)(state),
    userCoordinates: getCoordinates(state),
    fetchingCoordinatesPending: isFetchingCoordinatesPending(state),
    countryCoordinates: getCoordinatesFromCountryCode(countryCode)
  };
};

const mapDispatchToProps = {
  fetchCoordinates,
  filterShops,
  fetchShops,
  fetchShopsDetails,
  changePage,
  selectShop
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withTranslation()
)(ShopMap);
